"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LiferayContext = {
    languageId: Liferay.ThemeDisplay.getBCP47LanguageId().slice(0, 2),
    languageTag: Liferay.ThemeDisplay.getBCP47LanguageId(),
    contextPath: Liferay.ThemeDisplay.getPathContext(),
    themeImagesPath: Liferay.ThemeDisplay.getPathThemeImages(),
    timeZone: Liferay.ThemeDisplay.getTimeZone(),
    spriteMapPath: `${Liferay.ThemeDisplay.getPathThemeImages()}/clay/icons.svg`,
    graphqlEndpoint: '/o/graphql',
    isLR: true,
    isMobile: Liferay.Browser.isMobile(),
    origin: window.location.origin,
    get pageId() {
        return Liferay.ThemeDisplay.getPlid();
    },
    get scopeGroupId() {
        return Liferay.ThemeDisplay.getScopeGroupId();
    },
    get layoutUrl() {
        return Liferay.ThemeDisplay.getLayoutURL();
    },
    navigatePath(path) {
        Liferay.SPA.app.navigate(path);
    },
};
exports.default = LiferayContext;
//# sourceMappingURL=liferay.js.map